import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/utils/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { LoaderService } from 'src/app/utils/services/loader.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-dashboard-video-list',
  templateUrl: './dashboard-video-list.component.html',
  styleUrls: ['./dashboard-video-list.component.scss']
})
export class DashboardVideoListComponent implements OnInit, OnDestroy {
  private category: string;
  dtOptions: DataTables.Settings = {};
  public allData: any;
  private isDtInitialized: boolean = false;
  public addCatName: string;
  public addCatRoute: string;
  public editCatRoute: string;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  constructor(
    private router: Router, 
    private apiService: ApiService, 
    private toastr: ToastrService,
    private LoaderService:LoaderService
  ) { }

  ngOnInit(): void {
    this.LoaderService.showLoader()
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
    this.showItem();
  }

  async showItem() {
    this.LoaderService.showLoader()
    const that = this;
    const data ={
      role:localStorage.getItem("role"),
      id:localStorage.getItem("id")
    }
    await this.apiService.getAllVideoList(data).subscribe((resp: any) => {
      console.log(resp.data);
      that.allData = resp.data;
      if (this.isDtInitialized) {
        this.LoaderService.hideLoader()

        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next();
        });
      } else {
        this.LoaderService.hideLoader()

        this.isDtInitialized = true;
        this.dtTrigger.next();
      }
    });
    // this.LoaderService.hideLoader()

  }
  async deleteItem(id, type) {
    this.LoaderService.showLoader();
  
    if (id == undefined || id == '') {
      this.toastr.error('User Id is Invalid');
      return false;
    }
  
    // Replace the confirm dialog with SweetAlert2
    if (id != undefined && id != '') {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'You won\'t be able to restore this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      });
  
      if (result.isConfirmed) {
        if (type.split(' ')[0] === 'Internal') {
          await this.apiService.deleteVideoById(id).subscribe((result: any) => {
            if (result.success) {
              this.LoaderService.hideLoader();
              this.toastr.success(result.message);
              this.showItem();
            } else {
              this.LoaderService.hideLoader();
              this.toastr.error(result.message);
            }
          });
        } else if (type.split(' ')[0] === 'External') {
          await this.apiService.deleteExternalVideoById(id).subscribe((result: any) => {
            if (result.success) {
              this.LoaderService.hideLoader();
              this.toastr.success(result.message);
              this.showItem();
            } else {
              this.LoaderService.hideLoader();
              this.toastr.error(result.message);
            }
          });
        }
      } else {
        this.LoaderService.hideLoader(); // If user cancels the deletion
      }
    } else {
      this.LoaderService.hideLoader(); // Hide loader if ID is invalid
    }
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

}
